import React from 'react'
import NavIcon from './navicon.component'
import { hideLink } from '../../utils/website.utils'
import { Translation } from 'react-i18next'
/**
 * @author Pragya Gupta
 *
 */

const trustLogo = '../../images/luotettava_kumppani_logo.png'

const Footer = ({ lang }) => {
  const getLink = (path) =>
    `https://invosy.com/fi${lang === 'fi' ? '' : '/en'}${path}`

  const links = {
    homepage: getLink('/'),
    pricing: getLink('/hinnoittelu/'),
    le: getLink('/kevytyrittaja/'),
    faq: getLink('/ukk/'),
    contact: getLink('/yhteystiedot/')
  }
  return (
    <Translation>
      {(t) => {
        return (
          <footer className="dashboard-footer">
            <div className="dashboard-footer-info">
              <div className="row">
                <article className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                  <h2 style={{ color: 'white', fontSize: '20px' }}>INVOSY</h2>
                  <ul>
                    <li style={{ fontSize: '16px' }}>Invosy Oy</li>
                    <li style={{ fontSize: '16px' }}>Salomonkatu 17 B,</li>
                    <li style={{ fontSize: '16px' }}>00100 HELSINKI</li>
                    <li style={{ fontSize: '16px' }}>
                      {t('code.1')} 3413106-8
                    </li>
                  </ul>
                </article>
                <article className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                  <h2 style={{ color: 'white', fontSize: '20px' }}>
                    {t('footer.h5')}
                  </h2>
                  <ul>
                    <li style={{ fontSize: '16px' }}>
                      <a
                        rel="noopener noreferrer"
                        href={links.homepage}
                        target="_blank"
                      >
                        {t('footer.etu')}
                      </a>
                    </li>
                    <li style={{ fontSize: '16px' }}>
                      <a
                        rel="noopener noreferrer"
                        href={links.pricing}
                        target="_blank"
                      >
                        {t('footer.hin')}
                      </a>
                    </li>
                    <li style={{ fontSize: '16px' }}>
                      <a
                        rel="noopener noreferrer"
                        href={links.le}
                        target="_blank"
                      >
                        {t('footer.kevy')}
                      </a>
                    </li>
                    <li style={{ fontSize: '16px' }}>
                      <a
                        rel="noopener noreferrer"
                        href={links.faq}
                        target="_blank"
                      >
                        {t('footer.kysy')}
                      </a>
                    </li>
                  </ul>
                </article>
                <article className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                  <h2 style={{ color: 'white', fontSize: '20px' }}>
                    {t('footer.h5a')}
                  </h2>
                  <ul>
                    <li style={{ fontSize: '16px' }}>
                      <a
                        rel="noopener noreferrer"
                        href={links.homepage}
                        target="_blank"
                      >
                        {t('footer.link1')}
                      </a>
                    </li>
                    <li style={{ fontSize: '16px' }}>
                      <a
                        rel="noopener noreferrer"
                        href={links.contact}
                        target="_blank"
                      >
                        {t('footer.link2')}
                      </a>
                    </li>
                  </ul>
                </article>
                <article className="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                  <h2 style={{ color: 'white', fontSize: '20px' }}>
                    {t('footer.h5b')}
                  </h2>
                  <ul>
                    <li style={{ fontSize: '16px' }}>
                      {t('code.puh')} 020 734 6903
                    </li>
                    <li style={{ fontSize: '16px' }}>
                      asiakaspalvelu@invosy.com
                    </li>
                    <li style={{ fontSize: '16px' }}>
                      <a onClick={hideLink} style={{ cursor: 'pointer' }}>
                        {t('footer.link3')}
                      </a>
                    </li>
                  </ul>
                </article>
              </div>
              <div className="row">
                <div className="dashboard-footer-some">
                  <article>
                    <ul
                      //className="nav nav-pills nav-justified"
                      style={{ display: 'flex' }}
                    >
                      <li style={{ marginLeft: 15 }}>
                        <a
                          rel="noopener noreferrer"
                          href="https://www.facebook.com/profile.php?id=61556170676438"
                          target="_blank"
                        >
                          <NavIcon
                            sectionClass="dashboard-footer-icon"
                            name="facebook-official"
                            size="2x"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          href="https://www.instagram.com/invosyfi/"
                          target="_blank"
                        >
                          <NavIcon
                            sectionClass="dashboard-footer-icon"
                            name="instagram"
                            size="2x"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noopener noreferrer"
                          href="https://www.linkedin.com/company/101773862/"
                          target="_blank"
                        >
                          <NavIcon
                            sectionClass="dashboard-footer-icon"
                            name="linkedin"
                            size="2x"
                          />
                        </a>
                      </li>
                    </ul>
                  </article>
                </div>
              </div>
              <div className="row" style={{ textAlign: 'center' }}>
                <a
                  rel="noopener noreferrer"
                  href="https://www.tilaajavastuu.fi/fi/"
                  target="_blank"
                >
                  <img
                    className="dashboard-footer-trustBrand"
                    src={trustLogo}
                    alt="luotettava_kumppani_laskutuspalvelu_yrittäjille"
                  />
                </a>
              </div>
              <div className="dashboard-footer-sign">
                <p style={{ fontSize: '14px' }}>
                  {' '}
                  &copy; Invosy {new Date().getFullYear()}
                </p>
              </div>
            </div>
          </footer>
        )
      }}
    </Translation>
  )
}

export default Footer
